import { Component, Input, ViewChild } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { DocumentTypeBaseComponent } from '../../document-types-base.component';
import { ElynkPacketSelectComponent } from '../elynk-packet-select/elynk-packet-select.component';
import { ActionService } from 'src/app/services/actions/action.service';

@Component({
    selector: 'app-elynk',
    templateUrl: './elynk.component.html',
    styleUrls: ['./elynk.component.scss']
})
export class ElynkComponent extends DocumentTypeBaseComponent {
    constructor(
        public configurationService: ConfigurationService,
        public actionService: ActionService

    ) {
        super(configurationService, actionService);
    }

    @Input() documentTypeId: number;

    @Input() active: boolean = false;

    @ViewChild('packetSelect', {static: false}) packetSelect: ElynkPacketSelectComponent;

    clearElynk() {
        this.packetSelect.clearPackets();
    }

}
